import { useMemo } from 'react';
import { useMissionStore } from '../../shared/store/useMissionStore';
import { CohortAssessmentStatus } from '@edwin-group/cj-graphql';
import { useAssessmentStore } from '../store/useAssessmentStore';
import { useChapterStore } from '../../shared/store/useChapterStore';
import { useRoot } from './useRoot';

export const useStartNewAssessment = (selectedCohortId?: string) => {
  useRoot();

  const mission = useMissionStore((state) => state.mission);
  const chapter = useChapterStore((state) => state.chapter);
  const cohorts = useAssessmentStore((state) => state.cohorts);

  const isFirstChapter = useMemo(() => {
    return mission?.chapters?.[0]?.uuid === chapter?.uuid;
  }, [mission, chapter]);

  const isLastChapter = useMemo(() => {
    return mission?.chapters?.[mission?.chapters?.length - 1]?.uuid === chapter?.uuid;
  }, [mission, chapter]);

  const selectedCohort = useMemo(() => {
    if (!selectedCohortId) return null;
    return cohorts?.find((cohort) => cohort.documentId === selectedCohortId);
  }, [cohorts, selectedCohortId]);

  const shouldEnableStartNewAssessment = useMemo(() => {
    if (isFirstChapter) return true;
    if (!isLastChapter) return false;
    if (!selectedCohortId || !selectedCohort) return false;
    return true;
  }, [selectedCohortId, selectedCohort, isFirstChapter, isLastChapter]);

  const cohortHasPreAssessment = useMemo(() => {
    if (!selectedCohort) return false;
    return (
      selectedCohort.assessmentStatus === CohortAssessmentStatus.PreAssessmentCreated ||
      selectedCohort.assessmentStatus === CohortAssessmentStatus.PostAssessmentCreated
    );
  }, [selectedCohort]);

  return {
    shouldEnableStartNewAssessment,
    cohortHasPreAssessment,
    selectedCohort,
  };
};
